import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Translate } from 'react-localize-redux';
import { reportActions } from '../../store/reportStore';
import { isNullOrUndefined } from '../../store/storeFunctions';
import Paging from '../common/pagingComponent';
import ExcelExportButton from '../common/excelExportButton';
import CustomTooltip from "../common/customTooltip";

class GrantsData extends React.Component {
    nameColumns = {};
    state = { page: 1 };

    get section() {
        return this.props.sections.find(o => o.id === this.props.sectionId);
    }

    get pageSize() {
        const limits = this.props.getSectionLimits(this.props.reportType, this.props.sectionId);
        return this.section.isLimited ? limits.pageSize.limited : limits.pageSize.unlimited;
    }

    render() {
        const { data, loadingMoreData, isLimited } = this.section;

        if (isNullOrUndefined(data) || isNullOrUndefined(data.items))
            return null;

        const max = data && isLimited && data.items.length > this.pageSize * this.state.page ? this.pageSize * this.state.pag : data.items.length;

        return (
            <div>
                <table className="table table-report-section">
                    <thead>
                        <tr>
                            <th className="w-10"><Translate id="Report.Grants.Period" /></th>
                            <th className="w-10"><Translate id="Report.Grants.GrantNumber" /></th>
                            <th className="w-30"><Translate id="Report.Grants.ProjectName" /></th>
                            <th className="w-15"><Translate id="Report.Grants.Provider" /></th>
                            <th className="w-15"><Translate id="Report.Grants.Amount" /></th>
                            <th className="w-5"><Translate id="Common.Currency" /></th>
                            <th className="w-15"><Translate id="Report.Grants.FinancialSource" /></th>
                            <th className="w-15"><Translate id="Report.Grants.Source" /></th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.items.slice(0, max).map(g => this.renderGrantRow(g))}
                        {isLimited && (data.items.length < data.totalCount || data.items.length > max) &&
                            this.renderMoreLinks(data.items.length, data.totalCount, loadingMoreData)}
                    </tbody>
                </table>
                {!isLimited && data.totalCount > this.pageSize && <div style={{ marginTop: "2em" }}>
                    <Paging
                        justify="center"
                        selectedPage={this.state.page}
                        totalPages={Math.ceil(data.totalCount / this.pageSize)}
                        setPage={page => this.onChangePage(page)}
                    />
                </div>}
                <ExcelExportButton link={this.section.link} entityId={this.props.id} report={this.props.reportType} />
            </div>
        )
    }

    renderGrantRow = (grant) => {
        return (
            <tr key={grant.rowId} className='colorize'>
                <td className="w-10">{grant.period}</td>
                <td className="w-10" style={ this.getGrantNumberStyle(grant.contractNumber) }>{this.getGrantNumber(grant.contractNumber)}</td>
                <td className="w-30">{grant.name}</td>
                <td className="w-15">{grant.provider}</td>
                <td className="w-15">{grant.amount}</td>
                <td className="w-5">{grant.currency}</td>
                <td className="w-15">{grant.financialSource}</td>
                <td  id={"tt"+grant.rowId} className="w-15">{grant.source}
                <CustomTooltip textAlign="right" placement='left' id={"tt"+grant.rowId} text={grant.sourceDescription} hideIcon delay={{ "show": 0, "hide": 0 }} innerClassName='tooltipSection'>
                        </CustomTooltip>
                </td>
            </tr>
        )
    }

    renderMoreLinks = (loadedCount, totalCount, isLoading) => {
        return (
            <tr>
                <td colSpan={8}>
                    <div>
                        {this.state.page >= 2
                            ? <a href={this.props.getUnlimitedSectionLink(this.props.reportType, this.props.id, this.props.sectionId)}
                                target="_blank" className="link-functional">
                                <Translate id="Report.Common.ShowAll" />&nbsp;({totalCount})
                            </a>
                            : <span className="link-functional" onClick={() => this.getMore(loadedCount)} ><Translate id="Report.Common.More" /></span>}
                    </div>
                    {isLoading === true && <div style={{ width: "100%" }} className="search-progress searching"></div>}
                </td>
            </tr>
        );
    }

    getMore = (loadedCount) => {
        this.props.fetchMoreData(
            [this.props.sectionId],
            { count: this.pageSize, offset: loadedCount, report: this.props.reportType },
            null, this.concatData, () => this.setState({ page: 2 })
        );
    }

    onChangePage = (page) => {
        this.props.fetchMoreData(
            [this.props.sectionId],
            { count: this.pageSize, offset: (page - 1) * this.pageSize, report: this.props.reportType },
            null, this.replaceData, () => this.setState({ page: page })
        );
    }

    concatData = (_hint, oldData, newData) => {
        return {
            items: oldData.items.concat(newData.items),
            totalCount: oldData.totalCount
        }
    }

    replaceData = (_hint, _oldData, newData) => newData;
    getGrantNumberStyle = (num) => (isNullOrUndefined(num) || !num.trim().match(/^([a-zA-Z]|[0-9])+$/)) ? undefined : { wordBreak: "break-word" };
    getGrantNumber = (num) => isNullOrUndefined(num) ? null : num.replace("/", "/\u200b").replace(".", ".\u200b");
}

export default connect(
    state => state.report,
    dispatch => bindActionCreators(reportActions, dispatch)
)(GrantsData);